import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "max-w-[40rem] mx-auto pb-24" }
const _hoisted_2 = { class: "flex flex-col gap-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-5 mt-10 px-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-[40px] font-black text-center leading-10" }, "Resource Library"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "From career advices to employer branding guides, there’s resource available to you.")
], -1)
const _hoisted_4 = { class: "w-7 h-7 mr-1 flex items-center justify-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "flex-grow text-left text-sm" }, "Search for titles here", -1)
const _hoisted_6 = { class: "w-7 h-7 bg-light-gray-100 flex flex-col items-center justify-center rounded-md p-1 text-light-gray-200" }
const _hoisted_7 = {
  key: 0,
  class: "m-auto text-center font-semibold py-10"
}

import { ref, onMounted, watch, computed } from "vue"
  import { useRoute, useRouter } from "vue-router"
  import { useResourcesStore } from "@/store/resources"
  import { IonContent, loadingController, IonInfiniteScroll, IonInfiniteScrollContent, IonPage, InfiniteScrollCustomEvent } from "@ionic/vue"

  import { search, optionsOutline } from "ionicons/icons"
  import Menubar from "@/components/menuBar.vue"
  import ResourcesImage from "@/components/resources/ResourcesImage.vue"
  import ResourceSearchpage from "@/components/resources/ResourceSearchpage.vue"

  import CompanyImage from "@/assets/images/discover/company-image.png"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ResourcesHomepage',
  setup(__props) {

  const route = useRoute()
  const router = useRouter()
  const resourcesStore = useResourcesStore()

  const resourcesList = ref<any>([])
  const queryParams = computed({
    get: () => resourcesStore.resourcesFilters,
    set: (val) => resourcesStore.setResourcesFilters(val),
  })
  const formatFilters = ["article", "podcast", "e-book"]
  const audienceFilters = ["All", "Employers", "Professionals"]
  const topicsData = [
    "All",
    "Benefits & Perks",
    "Career Advice",
    "Career Progression",
    "Challenge Work",
    "Community Contribution",
    "Company Culture",
    "Company Reputation",
    "Diversity/Inclusion",
    "Employee Empowerment",
    "Employee Recognition",
    "Employer Branding",
    "Fun & Passion",
    "Innovation",
    "Job Flexibility",
    "Job Hunting",
    "Job Satisfaction",
    "Job Stability",
    "Leadership",
    "Learning & Development",
    "People Management",
    "Teams",
    "Technology",
    "Traditions & Events",
    "Vision, Mission & Values",
    "Work-Life Balance",
    "Work Environment",
  ]
  const noMoreData = ref(false)

  /**
   * set format filter
   */
  const formatFilter = () => {
    if (route.params.type && formatFilters.includes(route.params.type as string)) {
      queryParams.value.format = (route.params.type as string).charAt(0).toUpperCase() + (route.params.type as string).slice(1)
    } else queryParams.value.format = "all"

    const audience = route.query.audience && audienceFilters.includes(route.query.audience as string) ? (route.query.audience as string) : "All"
    if (queryParams.value.audience !== audience) {
      queryParams.value.audience = audience
    }

    const topic = route.query.topic && topicsData.includes(route.query.topic as string) ? (route.query.topic as string) : "All"
    if (queryParams.value.topic !== topic) {
      queryParams.value.topic = topic
    }
  }

  /**
   *
   * @param event - infinite scroll custom event
   *
   * set offset params
   */
  const addOffset = async (event: InfiniteScrollCustomEvent) => {
    queryParams.value.offset += 10
    event.target.complete()
  }

  /**
   * add fetch resources data
   */
  const addFetchResource = async () => {
    const data = await resourcesStore.retrieveResources(queryParams.value)
    if (data?.length) {
      resourcesList.value = resourcesList.value.concat(data)
      if (data.length < 10) noMoreData.value = true
    } else noMoreData.value = true
  }

  /**
   * fetch resources data
   */
  const fetchResource = async () => {
    const loading = await loadingController.create({
      spinner: null,
      message: "Retrieving...",
      translucent: true,
      backdropDismiss: false,
    })
    await loading.present()
    queryParams.value.offset = 0
    const data = await resourcesStore.retrieveResources(queryParams.value)
    if (data) resourcesList.value = data
    if (data && data.length < 10) noMoreData.value = true
    else noMoreData.value = false
    loading.dismiss()
  }

  onMounted(() => {
    formatFilter()
    fetchResource()
  })

  watch(
    () => router.currentRoute.value,
    () => formatFilter()
  )
  watch(
    () => [queryParams.value.format, queryParams.value.audience, queryParams.value.topic],
    () => fetchResource()
  )
  watch(
    () => queryParams.value.offset,
    () => addFetchResource()
  )

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_nav_link = _resolveComponent("ion-nav-link")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Menubar),
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_ion_nav_link, {
                "router-direction": "forward",
                component: ResourceSearchpage
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    color: "white",
                    size: "large",
                    class: "text-xl text-primary-black normal-case flex flex-row justify-between items-center gap-5"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, [
                        _createVNode(_component_ion_icon, { icon: _unref(search) }, null, 8, ["icon"])
                      ]),
                      _hoisted_5,
                      _createElementVNode("span", _hoisted_6, [
                        _createVNode(_component_ion_icon, { icon: _unref(optionsOutline) }, null, 8, ["icon"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_ion_list, { lines: "none" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resourcesList.value, (resources) => {
                  return (_openBlock(), _createBlock(_component_ion_item, {
                    key: `${resources}_id`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ResourcesImage, {
                        data: resources.data
                      }, null, 8, ["data"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (!resourcesList.value.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, "No resources found."))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (!noMoreData.value && resourcesList.value.length)
              ? (_openBlock(), _createBlock(_unref(IonInfiniteScroll), {
                  key: 0,
                  id: "infinite-scroll",
                  threshold: "100px",
                  onIonInfinite: _cache[0] || (_cache[0] = ($event: any) => (addOffset($event)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonInfiniteScrollContent), {
                      "loading-spinner": "bubbles",
                      "loading-text": "Loading more data..."
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})